export function init() {

  console.log("page init");
  // jQuery(".item-holder.active").on("mouseout", function () {
  //   jQuery(this).removeClass("active");
  // });

  // jQuery(".modal .close").on("click", function () {
  //   hideModal();
  // });

  jQuery(".showhide_button").on("click", function () {
  var thisid = jQuery(this).data("id");

  var contentWrapper = jQuery('.showhide_content[data-id="' + thisid + '"]');
  console.log("showhide_button: ", thisid);
  contentWrapper.toggleClass("open");
  console.log("open? " , contentWrapper.hasClass("open"));
  jQuery(this).toggleClass("open");
  if (jQuery(this).hasClass("open")) {
    jQuery(this).html("Read Less");
  } else {
    jQuery(this).html("Read More");
  }
});
}



function showModal(html) {
  jQuery(".modalcontent").html(html);
  jQuery(".modal").show();
}

function hideModal() {
  jQuery(".modal").hide();
} 

function scrollTo(tothis, paddingtop) {
  animating = true;
  if (tothis != "") {
    tothis = jQuery(tothis);

    gotothis = tothis.offset().top - paddingtop;

    jQuery("html, body").animate(
      {
        scrollTop: gotothis,
      },
      300,
      function () {
        setTimeout(function () {
          animating = false; // after 250ms give control back.
        }, 250);
      },
    );
  }
}
